import { Space, Button, Divider, Avatar, Typography ,Rate, Input,Radio,Select, InputNumber,Checkbox, message, Grid,Image} from "antd";
import R2Footer from "../../../components/Footer";
import { ArrowLeftOutlined, CloseOutlined, RightCircleOutlined } from "@ant-design/icons";
import styles from "./style.module.scss";
import "./style.scss"
import { useState,useEffect } from "react";
import { useHistory, useRouteMatch ,useLocation} from "react-router-dom";
import { useSelector } from 'react-redux';
import Spinner from "../../../components/Layout/Spinner";

import TextArea from "antd/lib/input/TextArea";
import OrderButton from "../../../components/OrderButton";
import PosService from "../../../services/PosService";
import EmployeeService from "../../../services/EmployeeService";
import PaymentSelectModal from "./PaymentSelectModal";
import cashRed from "../../../assets/images/Cash-red.svg";
import onlineRed from "../../../assets/images/Online-red.svg";
import terminalRed from "../../../assets/images/Terminal-red.svg";
import cashBlack from "../../../assets/images/Cash-black.svg";
import onlineBlack from "../../../assets/images/Online-black.svg";
import terminalBlack from "../../../assets/images/Terminal-black.svg";

const { Title, Text } = Typography;
const { Option } = Select;
const CheckboxGroup = Checkbox.Group;
const plainOptions = ['P1', 'P2', ];
const { useBreakpoint } = Grid;

const Item = ({ cart_item_id,name, quantity, description, sides, price, isLast,splitValue,splitItem,splitTypes }) => {
	const [checkedList, setCheckedList] = useState([]);
	   const screens = useBreakpoint();

	const onChange = (list) => {
		setCheckedList(list);
		splitTypes(list,cart_item_id)
	  };
	  const handleChange = (value) => {
		splitTypes(value,cart_item_id)
	  };

	return (
		<>
			<div
  style={{
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    gap: "15px",
    flexWrap: !screens.md ? "wrap" : "nowrap",
    marginBottom: !screens.md && "10px",
  }}
>
				<div style={{ width: "80%", display: "flex" }}>
					<div className="pos-menu-summary-items">
						<div className= {screens.md ? "pos-desktop-quantity" : "pos-mobile-quantity"} >
							{quantity}{" "}
							<CloseOutlined
								style={{ marginLeft: "10px", marginRight: "10px" }}
							/>{" "}
							
						</div>
						<div >
						<div className={screens.md ? "pos-desktop-quantity summary-menus" : "pos-mobile-quantity summary-menus"}>
							{name}
						</div>
						<div className="summary-menus">
							<div type="secondary">
								{description}
							</div>
							<div>
								sides: {sides}
							</div>
						</div>
					</div>
					</div>
				</div>
				<div  className= {screens.md ? "pos-desktop-quantity" : "pos-mobile-quantity"}>${price}</div>
				{splitValue == 3 && splitItem.length > 2 && (
  <div
    className="person-select"
    style={{
      width: screens.md ? "auto" : "100%",
      marginTop: !screens.md ? "10px" : 0,
    }}
  >
    <Select
      mode="multiple"
      onChange={handleChange}
      style={{ width: screens.md ? 200 : "100%" }}
    >
      {splitItem.map((itemValue) => (
        <Option key={itemValue.value} value={itemValue.value}>
          {itemValue.label}
        </Option>
      ))}
    </Select>
  </div>
)}
					{splitValue == 3 && splitItem.length == 2 && (
  <div
    style={{
      width: screens.md ? "auto" : "100%",
      marginTop: !screens.md ? "10px" : 0,
    }}
  >
    <CheckboxGroup
      className="people-check"
      options={plainOptions}
      value={checkedList}
      onChange={onChange}
    />
  </div>
)}
			</div>
		
			
		</>
	);
};


const OrderPayment = () => {

   const screens = useBreakpoint();

	const history = useHistory();
	const adminRestaurant = useSelector((state) => state.admin)
	const [carts, setCarts] = useState([])
	const [cartDetails, setCartDetails] = useState()
	const [serverData, setServerData] = useState()
	const [value, setValue] = useState(1);
	const [splitEquallyNumber, setSplitEquallyNumber] = useState(2);
	const [splitItem, setSplitItem] = useState([{label:"Person 1",value:1,percentage:100/2},{label:"Person 2",value:2,percentage:100/2}]);
	const [splitModel,setSplitModel] = useState([])
	const [selectedPayment,setSelectedPayment] = useState()
	const params = useLocation()
	const orderId = params.search.split("=")[1]
	const orderNum = params.search.split("=")[2]
	const [loading, setLoading] = useState(false);
	const [ratingPayload, setRatingPayload] = useState();
	const [customerPayload, setCustomerPayload] = useState();
	const [addModal, setAddModal] = useState(false);

	


	
	useEffect(() => { 
	
		(async () => {
			
			// const orderItems = await PosService.getPosOrder(orderId)
		   const cartItems = await PosService.getPosCart(adminRestaurant,localStorage.getItem("tableId") && Number(localStorage.getItem("tableId")))
		   setCarts(cartItems?.cart_items.filter(item=>item.quantity != 0))
		   setCartDetails(cartItems)
		   const employee = await EmployeeService.getEmployeeById(localStorage.getItem("serverId") && Number(localStorage.getItem("serverId")))
		   setServerData(employee)

		   const reviewObj={
			order_id: Number(orderNum),
			delivery_employee_id: undefined,
			server_employee_id: localStorage.getItem("serverId") && Number(localStorage.getItem("serverId")),
			review: "",
			delivery_rating: 1,
			pricing_rating: 1,
			service_rating: 1,
			ambience_rating: 1,
			taste_rating: 1
		   }
		   setRatingPayload(reviewObj)
		})();
	  }, []);
	
	const onChange = (e) => {
		setValue(e.target.value);
		setSplitModel([])
		setSplitEquallyNumber(2)
		setSplitItem([{label:"Person 1",value:1,percentage:100/2},{label:"Person 2",value:2,percentage:100/2}])
	  };
	 

	  const addCount= async(menuItem,isAdd)=>{
		if(isAdd)
		{
			setSplitEquallyNumber(splitEquallyNumber+1)
			// if(value==3)
			// {
				const splits=Array.from({length: splitEquallyNumber+1}, (_, i) => i + 1)
				setSplitItem(splits.map(item=>{
					return{
						label: "Person "+item,
						value: item,
						percentage:100/splits.length
					}
				}))
				
			// }
		}
		else{
			setSplitEquallyNumber(splitEquallyNumber-1)
			// if(value==3)
			// {
				const splits=Array.from({length: splitEquallyNumber-1}, (_, i) => i + 1)
				setSplitItem(splits.map(item=>{
					return{
						label: "Person "+item,
						value: item,
						percentage:100/splits.length
					}
				}))
			// }
		} 

		
  }
  const getSplitModelTypes = (list,itemId)=>{
	console.log(list)
	const newSplit = splitModel.filter(item=>item != undefined).filter(item=>item.item_id != itemId)
	for(var i=0;i<list.length;i++){
		const obj = {
			split_number: i+1,
			item_id: itemId,
			personId:list[i]
		}
		newSplit.push(obj)
	}
	setSplitModel(newSplit)
}

	const postSplitDeatails =async ()=>{
		setLoading(true)
		let splits ={}
		if(value==1)
		{
			 splits={
				order_num: orderId,
				split_type:"NO_SPLIT",
				items:[
					{
						split_number: 1,
						percentage: 1,
						price: cartDetails?.total
					}
				]
			}
		}
		if(value == 2)
		{
			
			 splits={
				order_num:orderId,
				split_type:"SPLIT_EQUALLY",
				items: splitItem.map(item=>{
					const obj={
						split_number: item.value,
						percentage: 1/splitItem.length,
						price: cartDetails?.total/splitItem.length
					}
					return obj
				})
				
			}
		}
		if(value == 3)
		{
			
			 splits={
				order_num:orderId,
				split_type:"SPLIT_BY_ITEM",
				items: splitModel.filter(item=>item !=undefined).map(item=>{
					console.log(splitModel)
					const cartPrice = splitModel.filter(itemU=>itemU !=undefined).filter(itemP=>itemP.item_id == item.item_id);
					console.log(((carts.find(cart=>cart.cart_item_id == item.item_id )?.quantity*carts.find(cart=>cart.cart_item_id == item.item_id )?.price)/cartPrice?.length)+(cartDetails?.taxes/splitModel.length),
					carts.find(cart=>cart.cart_item_id == item.item_id )?.quantity,"1",carts.find(cart=>cart.cart_item_id == item.item_id )?.price,cartDetails?.taxes/splitModel.length)
					const obj={
						split_number: item.split_number,
						percentage: 1/splitItem.length,
						item_id: carts.find(cart=>cart.cart_item_id == item.item_id )?.menu_item_id,
						price: ((carts.find(cart=>cart.cart_item_id == item.item_id )?.quantity*carts.find(cart=>cart.cart_item_id == item.item_id )?.price)/cartPrice?.length)+(cartDetails?.taxes/splitModel.length)
					}
					return obj
				})
				
			}
		}
		if(value == 4)
		{
			
			 splits={
				order_num: orderId,
				split_type:"SPLIT_BY_PERCENT",
				items: splitItem.map(item=>{
					const obj={
						split_number: item.value,
						percentage: item.percentage/100,
						price: cartDetails?.total*(item.percentage/100)
					}
					return obj
				})
				
			}
		}
		const splitCartItems = await PosService.posSplitOrder(splits)
		
		if(splitCartItems?.data?.err)
		 message.error(splitCartItems?.data?.msg)

		 
		if(customerPayload)
		{
			customerPayload.restaurant_id = adminRestaurant;
		 const customer = await PosService.posCustomer(customerPayload)
		 ratingPayload.customer_id = customer?.id
		 const rate = await PosService.posRateOrder(ratingPayload)
		}
		else{
			const rate = await PosService.posRateOrder(ratingPayload)
			
		}

		 

		 setLoading(false)
		 setAddModal(true)

	}

	const onChangePercentage =(e,itemSplit)=>{
		const updatePercent = splitItem.filter(item=>item != undefined).map(item=>{
			return {...item,percentage:itemSplit.value == item.value ? e:item.percentage}
		})
      setSplitItem(updatePercent)
	}

	
	const customerChange =(event,type)=>{
		
		setCustomerPayload({...customerPayload,[type]:event.target.value})
		console.log(customerPayload)

	}
	const posReview =(event)=>{
		
		const rate = ratingPayload;
		rate.review = event.target.value;
		setRatingPayload(rate)
	}
	const closeModal = (status) => {
		setAddModal(status)
	}
	const ratingCgange =(event,type)=>{
		const rate = {...ratingPayload};
		rate[type] = event;
		setRatingPayload(rate)

	}

	return (
		<>
			<div className="container" style={{ background: "#fdf8f9" }}>
				<div
					style={{
						padding: screens.md ?50:18,
						width: screens.md ?"75%" :"100%",
						minHeight: 280,
						position: "relative",
					}}
				>
					<Space size={"large"} direction="vertical" style={{ width: "100%" }}>
						<div className={styles.backBtn}>
							<ArrowLeftOutlined style={{ color: "#C32340" }}
							onClick={()=> history.push(`/pos/menus/server-menu?id=${localStorage.getItem("menuId")}`)} />
							<span>Back to Menu</span>
						</div>
						<div className={styles.dataContainer} style={{padding: !screens.md && "10px"}}>
                        <div className={screens.md ? styles.server :"summary-server"}>
								<Title level={screens.md ? 4: 5}>Select Payment</Title>
								<div className={styles.serverDetails}>
									<div className="payment-selectors">
										<Button onClick={()=>setSelectedPayment("Terminal")}>
											 <Image
																  src={selectedPayment === "Terminal"?terminalRed:terminalBlack}
																  alt="Banner"
																  preview={false}
																  width={18}
																  style={{marginRight:"5px"}}
																  
																/>
											Terminal</Button>
										<Button onClick={()=>setSelectedPayment("Online")}>
											 <Image
																  src={selectedPayment === "Online"?onlineRed:onlineBlack}
																  alt="Banner"
																  preview={false}
																  width={18}
																  style={{marginRight:"5px"}}
																/>
											Online</Button>
                                        <Button onClick={()=>setSelectedPayment("Cash")}> <Image
																  src={selectedPayment === "Cash"?cashRed:cashBlack}
																  alt="Banner"
																  preview={false}
																  width={18}
																  style={{marginRight:"5px"}}
																  
																/>Cash</Button>
									</div>
								</div>
							</div>
                            <Divider style={{ backgroundColor: "black",opacity: !screens.md && "20%"  }} />

							<div className={screens.md ? styles.server :"summary-server"}>
								<Title level={screens.md ?4: 5}>Split Bill</Title>
								<div className={styles.serverDetails}>
									<div>
									<div>
									<Radio.Group onChange={onChange} value={value}
									className={screens.md? "" :"split-types-mobile"}>
      								<Radio value={1}>No Split</Radio>
									<Radio value={2}>Split Equally</Radio>
									<Radio value={3}>Split by item</Radio>
									<Radio value={4}>Split by percentage</Radio>
   									 </Radio.Group>
									</div>
									{(value == 2 || value == 3 || value == 4) && 
									<div className="split-equally">
										<div className="flex">
										<div className="person-split"> 
									{"Among: "}
									</div><OrderButton
											count={splitEquallyNumber}
											increment={() => addCount([],true)}
											decrement={() => addCount([],false)}
											/>
											</div>
											{(value == 2 ||  value == 4) && 
											<div className="split-percentage">
												{splitItem.map(item=>
													<div className="split-percent-item">
														<div className="person-split">
														{item.label+" Split"}
														</div>
															<InputNumber
															value={item.percentage && Math.round(item.percentage * 100) / 100}
															min={0}
															max={100}
															disabled={value==2?true:false}
															formatter={(value) => `${value}%`}
															parser={(value) => value.replace('%', '')}
															onChange={(event)=>onChangePercentage(event,item)}
															/>
													</div>)}
												</div>}
											</div>
}
											</div>
								</div>
							</div>
                            <Divider style={{ backgroundColor: "black" , opacity: !screens.md && "20%" }} />

							<div className={screens.md ? styles.server :"summary-server"}>
								<Title level={screens.md ? 4 :5}>SERVER</Title>
								<div className={screens.md ? styles.serverDetails :"summary-server-head"}>
									<Avatar size={45} src={serverData?.photo_url}></Avatar>
									<div className={screens.md ? "" :"code-name"}>
										<Title level={screens.md ? 4: 5} style={{ color: "#C32340" }}>
										{serverData?.name}
										</Title>
										<Text type="secondary">
											Server code:{" "}
											<span style={{ color: "black" }}>
											{serverData?.restaurant_roles.find(item=>item.restaurant_id == adminRestaurant)?.employee_code}
											</span>
										</Text>
										<p></p>
									</div>
								</div>
							</div>
							<Divider style={{ backgroundColor: "black", opacity: !screens.md && "20%"  }} />
							<div >
							{value== 3 && splitItem.length > 2 &&
								<div className="people-involved">People Involved</div>}
								{value== 3 && splitItem.length == 2 &&
								<div className="two-people-heading">
								<div className="people-involved">People 1</div>
								<div className="people-involved second-people">People 2</div>
								</div>
								}
								<div className={screens.md ? styles.summary :"summary-server"}>
								<Title level={screens.md ?4: 5}>SUMMARY</Title>
								
								<div className={styles.items} style={{width: !screens.md && "100%"}}>
									{carts?.map((item, index, array) => {
										return (
											<Item
												key={index}
												isLast={index === array.length - 1}
												{...item}
												splitValue={value}
												splitItem={splitItem}
												splitTypes={getSplitModelTypes}
											/>
										);
									})}

                                    <div className={styles.taxes}>
                                    <div className={styles.name}>SubTotal</div>
                                    <div className={styles.amount}>${cartDetails?.subtotal}</div>
                                    </div>
									<div className={styles.taxes}>
                                    <div className={styles.name}>Taxes and Fees</div>
                                    <div className={styles.amount}>${cartDetails?.taxes}</div>
                                    </div>
                                    <Divider style={{ backgroundColor: "black", opacity: "0.15" }} />

                                    <div  className={styles.total}>
                                    <div  className={styles.totalName}>Total amount tobe paid</div>
                                    <div  className={styles.totalAmount}>${cartDetails?.total}</div>
                                    </div>
								</div>
								</div>
							</div>
							<Divider style={{ backgroundColor: "black", opacity: !screens.md && "20%"  }} />
						</div>
						<div className={screens.md ? styles.server :"summary-server"}>
								<Title level={screens.md?4:5}>Review</Title>
								<div className={styles.serverDetails}>
									<div className={screens.md ? "rate-offer": "split-types-mobile"}>
									<div>
										<div className={"rate"}>
											<div className="rate-type">Taste:</div>
											<div><Rate onChange={(event)=>ratingCgange(event,"taste_rating")}
												className={ratingPayload?.taste_rating === 5 ? "rate-green" : 
												ratingPayload?.taste_rating <= 4 ? "rate-yellow" : "rate-normal"}/></div>
										</div>
										<div className={"rate"}>
											<div className="rate-type">Ambience:</div>
											<div><Rate onChange={(event)=>ratingCgange(event,"ambience_rating")}
												className={ratingPayload?.ambience_rating === 5 ? "rate-green" : 
												ratingPayload?.ambience_rating <= 4 ? "rate-yellow" : "rate-normal"}/></div>
										</div>
										<div className={"rate"}>
											<div className="rate-type">Service:</div>
											<div><Rate onChange={(event)=>ratingCgange(event,"service_rating")}
												className={ratingPayload?.service_rating === 5 ? "rate-green" : 
												ratingPayload?.service_rating <= 4 ? "rate-yellow" : "rate-normal"}/></div>
										</div>
										<div className={"rate"}>
											<div className="rate-type">Pricing:</div>
											<div><Rate onChange={(event)=>ratingCgange(event,"pricing_rating")}
												className={ratingPayload?.pricing_rating === 5 ? "rate-green" : 
												ratingPayload?.pricing_rating <= 4 ? "rate-yellow" : "rate-normal"}/></div>
										</div>
										<TextArea placeholder="anything we can improve?" className="suggestion-box"
										onChange={posReview}/>
									</div>
									<Divider type={screens.md ? "vertical" :"horizontal"} />
									<div>
										<Title level={5} className="flex">Want to recieve offers</Title>
										<div className="offer-type">
											<div className="flex">Name</div>
											<Input placeholder="enter name" onChange={(event)=>customerChange(event,"name")}></Input>
										</div>
										<div className="offer-type">
											<div className="flex">Email Id</div>
											<Input placeholder="enter email id" onChange={(event)=>customerChange(event,"email")}></Input>
										</div>
										<div className="offer-type">
											<div className="flex">Phone Number</div>
											<Input placeholder="enter phone number" onChange={(event)=>customerChange(event,"phone_number")}></Input>
										</div>
									</div>
									</div>
								</div>
								
							</div>
							{screens.md &&
							<Button type="primary"
							onClick={()=> postSplitDeatails()}>Submit</Button>
}
					</Space>

					
				</div>
				{loading && <Spinner/>}
				{addModal &&
                <PaymentSelectModal modalOpen={true}  closeModal={closeModal} 
                 />}

				 {!screens.md &&
					 <div className="bottom-fixed-wrapper">
          {/* Top Menu Section */}
          <div>
          
          </div>

          {/* Cart Section */}
          <div className="cart-bar">
           <div></div>

            <div className="cart-right" onClick={()=> postSplitDeatails()}>
              <span>Checkout</span>
              <RightCircleOutlined />
            </div>
          </div>
        </div>
}
			</div>
			<R2Footer />
		</>
	);
};

export default OrderPayment;
